import { Injectable } from '@angular/core';
import { ConfigService } from '../core/config.service';
import { HttpClient } from '@angular/common/http';

export interface CreateGatewayStatus {
  deviceUuid: string;
  inProgress: boolean;
  downloadLink: string;
  error: string;
}

export interface CreatedGateway {
  device_uuid: string;
  download_link: string;
  expire_time: number;
  status: string;
  location_id: string;
  certs_issued?: boolean;
  // TODO: consider whether might be best to delete this for security, unnecessary to send this
  one_time_password: string;
  description?: string;
}

@Injectable()
export class GatewaySetupService {
  constructor(private configService: ConfigService, private httpClient: HttpClient) {}

  createGateway(body: any): Promise<CreateGatewayStatus> {
    const url = this.configService.getGatewayUrl() + '/gateway/create';
    return this.httpClient.post<CreateGatewayStatus>(url, body).toPromise();
  }

  getGatewaysRaw(): Promise<CreatedGateway[]> {
    const url = this.configService.getGatewayUrl() + '/gateway/list-raw';
    return this.httpClient.get<CreatedGateway[]>(url).toPromise();
  }
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/gateway-setup/gateway-setup.service.ts